module.exports = __webpack_public_path__ + "img/36_54.541c8bff.png";